import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { ArrowRight } from "lucide-react";

const STEPS = [
  ["adm_s1t", "adm_s1d"],
  ["adm_s2t", "adm_s2d"],
  ["adm_s3t", "adm_s3d"],
  ["adm_s4t", "adm_s4d"],
  ["adm_s5t", "adm_s5d"],
  ["adm_s6t", "adm_s6d"],
];

export default function Admissions() {
  const { t } = useI18n();
  return (
    <div>
      <div className="bg-ink text-paper">
        <Section className="py-20 md:py-28">
          <Eyebrow>{t("adm_eyebrow")}</Eyebrow>
          <h1 className="font-serif text-4xl md:text-6xl tracking-tight max-w-4xl">{t("adm_h1")}</h1>
          <p className="mt-6 max-w-2xl text-paper/70 text-lg leading-relaxed">{t("adm_sub")}</p>
          <Link to="/apply" data-testid="admissions-apply" className="mt-9 inline-flex items-center gap-2 bg-heraldic text-white px-7 py-3.5 rounded-sm hover:bg-heraldic-600 transition-colors">{t("hero_cta_apply")} <ArrowRight className="h-4 w-4" /></Link>
        </Section>
      </div>
      <Section className="py-16 md:py-24">
        <div className="grid gap-px bg-border border border-border md:grid-cols-2 lg:grid-cols-3">
          {STEPS.map(([tk, dk], i) => (
            <div key={tk} className="bg-paper p-8">
              <div className="font-mono text-sm text-heraldic">{t("adm_step")} {i + 1}</div>
              <div className="mt-2 font-serif text-2xl text-ink">{t(tk)}</div>
              <p className="mt-2 text-ink/65 leading-relaxed">{t(dk)}</p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
